import { BundleData } from 'client/bundles/types';
import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';
import React, { Component } from 'react';

import Cut, { RenderButtonType } from 'client/components/helpers/cut';

import CountryDescriptor from '../country-descriptor';

import './index.css';

type Size = [number, number];

const b = cn('adaptive-country-list');

interface Props {
    countries: BundleData['main']['geography']['countries'];
}

class AdaptiveCountryList extends Component<Props> {
    static contextType = LangContext;
    picRef = React.createRef<HTMLDivElement>();
    reducedCountriesCoords: Size[] = [];

    render() {
        const { countries } = this.props;

        return (
            <Cut count={1} renderButton={this.renderCutButton}>
                {countries.map(({ country, description, businessUnits }) => (
                    <div key={country} className={b('item')}>
                        <CountryDescriptor
                            country={country}
                            description={description}
                            businessUnits={businessUnits}
                            />
                    </div>
                ))}
            </Cut>
        );
    }

    private renderCutButton: RenderButtonType = (toggle, cutted) => {
        const { dictionary } = this.context;

        return (
            <button className={b('cut-button')} onClick={toggle}>
                {cutted ? dictionary.open_full_list : dictionary.hide_full_list}
            </button>
        );
    }
}

export default AdaptiveCountryList;
